import React, { useContext } from 'react'
import {
  PaymentErrorToast,
  SectionTitle,
  StepNavigationButtons,
  GenericModal
} from '@pinflag/pinflag-ui-kit'
import PropTypes from 'prop-types'

import { DataContext } from '../context/DataContext'
import { usePayment } from '../hook/payment/usePayment/usePayment'
import { useSteps } from '../hook/useSteps'
import { usePaymentHandlers } from '../hook/payment/usePaymentHandlers'
import { useShopify } from '../hook/useShopify'

import NativePaymentMethodSelection from './Payment/NativePaymentMethodSelection'
import { PinflagPaymentMethodSelection } from './Payment/PinflagPaymentMethodSelection'

// Helper function
export const doesCompanyHasPinflagPayments = (ownPayments) => {
  return ownPayments.active
}

const PaymentMethodSelection = ({
  scrapperClient,
  isPaymentRedirect,
  encryptedMessage
}) => {
  const { companyInfo, setIsProductSoldOut, isProductSoldOut } = useContext(DataContext)
  const { ownPayments, primaryColor, secondaryColor } = companyInfo
  const {
    isLoadingCheckIfCustomerHasSavedCards,
    hasConfirmedPaymentMethod,
    paymentError,
    setPaymentError
  } = usePayment()
  const { handleConfirmPaymentMethod, canUserGoToPay } = usePaymentHandlers({
    scrapperClient
  })
  const { goToPreviousStep } = useSteps()
  const { redirectToCartShopify } = useShopify()
  const handleClose = () => {
    setIsProductSoldOut(false)
    redirectToCartShopify()
  }

  return (
    <>
      <GenericModal
        isOpenModal={isProductSoldOut}
        icon='error'
        modalTitle='Producto agotado'
        modalText='Uno de tus productos está agotado. Debes dirigirte al carro.'
        secondButton='Volver al carro'
        handleAction={handleClose}
      />
      <div className="md:h-full md:w-[537px] md:text-[11px]">
        <div className="flex flex-col md:h-full">
          <div className="bg-slate-100 h-full pb-8">
            <div className="md:mx-4">
              <div className="bg-white rounded-md mx-2 md:mt-3 flex flex-col justify-around py-6 md:pt-3">
                <div className="relative w-full border-b-2 pb-2 mb-3">
                  <SectionTitle
                    iconName="credit-card"
                    title="Método de Pago"
                    className="ml-10"
                    primaryColor={primaryColor}
                  />
                  <PaymentErrorToast
                    paymentError={paymentError}
                    onClose={() => setPaymentError('')}
                  />
                </div>
                {doesCompanyHasPinflagPayments(ownPayments)
                  ? (
                  <PinflagPaymentMethodSelection
                    scrapperClient={scrapperClient}
                  />
                    )
                  : (
                  <NativePaymentMethodSelection scrapperClient={scrapperClient} />
                    )}
                {(!isLoadingCheckIfCustomerHasSavedCards ||
                  !doesCompanyHasPinflagPayments(ownPayments)) && (
                  <div className="px-11">
                    <StepNavigationButtons
                      labelOne="Atrás"
                      labelTwo="Pagar"
                      iconTwoName="credit-card"
                      iconOneName="arrow-back"
                      onClickOne={goToPreviousStep}
                      onClickTwo={handleConfirmPaymentMethod}
                      isDisabledOne={hasConfirmedPaymentMethod}
                      isDisabledTwo={
                        hasConfirmedPaymentMethod || !canUserGoToPay()
                      }
                      loadingSecondButton={hasConfirmedPaymentMethod}
                      buttonTwoColor={secondaryColor}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

PaymentMethodSelection.propTypes = {
  scrapperClient: PropTypes.string,
  isPaymentRedirect: PropTypes.bool,
  encryptedMessage: PropTypes.string
}

export default PaymentMethodSelection
